<div style="position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;width:600px;height:400px;text-align:center;font-family:\&quot;Exo2SemiBold\&quot;,sans-serif;line-height:50px;">
  <b style="display:block;font-size:32px;">Увага!</b><b style="display:block;font-size:32px;">На сайті проводяться технічні роботи!</b>
  <p style="display:block;font-size:24px;">Вибачте за тимчасові незручності. Найближчим часом все запрацює в штатному режимі.</p>
</div>
